"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var _propTypes = require("prop-types");
var _excluded = ["rows", "rowHeight"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var ParagraphPlaceholder = function ParagraphPlaceholder(_ref) {
  var rows = _ref.rows,
    rowHeight = _ref.rowHeight,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var placeholderRows = [];
  for (var i = 0; i < rows; i += 1) {
    placeholderRows.push(/*#__PURE__*/_react["default"].createElement("rect", {
      width: "100%",
      height: rowHeight,
      key: "placeholder-row".concat(i)
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_reactContentLoader["default"], _extends({
    viewBox: "0 0 100% ".concat(rowHeight),
    style: {
      height: rowHeight,
      width: '100%'
    }
  }, otherProps), placeholderRows);
};
ParagraphPlaceholder.defaultProps = {
  rows: 1,
  rowHeight: 12
};
ParagraphPlaceholder.propTypes = {
  rows: _propTypes.PropTypes.number,
  rowHeight: _propTypes.PropTypes.number
};
var _default = exports["default"] = ParagraphPlaceholder;